<template>
  <div class="max-w-3xl space-y-6">
    <div class="bg-white rounded-lg shadow p-6">
      <h2 class="text-xl font-bold mb-4">Profile</h2>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
        <div class="rounded-lg bg-gray-50 p-4">
          <div class="text-gray-500">Name</div>
          <div class="font-semibold">{{ authStore.user?.full_name || '-' }}</div>
        </div>
        <div class="rounded-lg bg-gray-50 p-4">
          <div class="text-gray-500">Email</div>
          <div class="font-semibold">{{ authStore.user?.email || '-' }}</div>
        </div>
        <div class="rounded-lg bg-gray-50 p-4">
          <div class="text-gray-500">Role</div>
          <div class="font-semibold capitalize">{{ authStore.user?.role || '-' }}</div>
        </div>
        <div class="rounded-lg bg-gray-50 p-4">
          <div class="text-gray-500">District</div>
          <div class="font-semibold">{{ authStore.user?.district?.name || authStore.user?.district_id || '-' }}</div>
        </div>
      </div>
    </div>

    <div class="bg-white rounded-lg shadow p-6">
      <h2 class="text-xl font-bold mb-4">Change Password</h2>
      <form @submit.prevent="submitPassword" class="space-y-4">
        <div>
          <label class="block text-sm font-medium mb-1">Current Password</label>
          <input v-model="form.currentPassword" type="password" required class="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-600" />
        </div>
        <div>
          <label class="block text-sm font-medium mb-1">New Password</label>
          <input v-model="form.newPassword" type="password" required minlength="8" class="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-600" />
        </div>
        <div>
          <label class="block text-sm font-medium mb-1">Confirm New Password</label>
          <input v-model="form.confirmPassword" type="password" required minlength="8" class="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-600" />
        </div>
        <button :disabled="authStore.loading" class="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50">
          {{ authStore.loading ? 'Updating...' : 'Update Password' }}
        </button>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Swal from 'sweetalert2'
import { useAuthStore } from '@/stores/authStore'

const authStore = useAuthStore()
const form = ref({ currentPassword: '', newPassword: '', confirmPassword: '' })

const submitPassword = async () => {
  if (form.value.newPassword !== form.value.confirmPassword) {
    Swal.fire({ icon: 'warning', title: 'Password Mismatch', text: 'New password and confirm password must match.', confirmButtonColor: '#3085d6' })
    return
  }

  const success = await authStore.changePassword(form.value.currentPassword, form.value.newPassword)
  if (success) {
    form.value = { currentPassword: '', newPassword: '', confirmPassword: '' }
    Swal.fire({ icon: 'success', title: 'Updated', text: 'Password updated successfully.', confirmButtonColor: '#3085d6' })
  } else {
    Swal.fire({ icon: 'error', title: 'Update Failed', text: authStore.error || 'Failed to update password.', confirmButtonColor: '#3085d6' })
  }
}

onMounted(() => {
  authStore.getProfile()
})
</script>
